export const formatPhonesToString = (phonesArray) => {
  return phonesArray.reduce(
    (total, current, currentIndex) => (total += `${currentIndex > 0 ? ' / ' : ''}(${current.areaCode}) ${current.number}`),
    ""
  );
};
